import { render, staticRenderFns } from "./ExternalFlashSale.vue?vue&type=template&id=3346d2ec&"
import script from "./ExternalFlashSale.vue?vue&type=script&lang=ts&"
export * from "./ExternalFlashSale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports